import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStars01 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.91666 10.8333L5.57037 12.1408C5.79161 12.5832 5.90223 12.8045 6.05002 12.9962C6.18115 13.1663 6.33366 13.3188 6.50378 13.45C6.6955 13.5978 6.91674 13.7084 7.35923 13.9296L8.66666 14.5833L7.35923 15.237C6.91674 15.4583 6.6955 15.5689 6.50378 15.7167C6.33366 15.8478 6.18115 16.0003 6.05002 16.1705C5.90223 16.3622 5.79161 16.5834 5.57037 17.0259L4.91666 18.3333L4.26294 17.0259C4.0417 16.5834 3.93108 16.3622 3.7833 16.1705C3.65216 16.0003 3.49965 15.8478 3.32953 15.7167C3.13781 15.5689 2.91657 15.4583 2.47409 15.237L1.16666 14.5833L2.47409 13.9296C2.91657 13.7084 3.13781 13.5978 3.32953 13.45C3.49965 13.3188 3.65216 13.1663 3.7833 12.9962C3.93108 12.8045 4.0417 12.5832 4.26294 12.1408L4.91666 10.8333Z",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 1.66667L12.9822 4.22035C13.2172 4.83137 13.3347 5.13689 13.5174 5.39387C13.6794 5.62163 13.8784 5.82062 14.1061 5.98257C14.3631 6.1653 14.6686 6.2828 15.2796 6.51781L17.8333 7.5L15.2796 8.48218C14.6686 8.71719 14.3631 8.8347 14.1061 9.01743C13.8784 9.17938 13.6794 9.37837 13.5174 9.60613C13.3347 9.86311 13.2172 10.1686 12.9822 10.7797L12 13.3333L11.0178 10.7797C10.7828 10.1686 10.6653 9.86311 10.4826 9.60613C10.3206 9.37837 10.1216 9.17938 9.89386 9.01743C9.63688 8.8347 9.33136 8.71719 8.72034 8.48218L6.16666 7.5L8.72034 6.51781C9.33136 6.2828 9.63688 6.1653 9.89386 5.98257C10.1216 5.82062 10.3206 5.62163 10.4826 5.39387C10.6653 5.13689 10.7828 4.83137 11.0178 4.22035L12 1.66667Z",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgStars01;
